// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"e351595a6dcff99662da","655":"284363c7adffd5dee7ff"}[chunkId] + ".js";
};